import { render, staticRenderFns } from "./foto.vue?vue&type=template&id=90e4150c&"
import script from "./foto.vue?vue&type=script&lang=js&"
export * from "./foto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput,QBtn,QDialog,QCard,QImg,QPagination} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput,QBtn,QDialog,QCard,QImg,QPagination})
